// MarketplaceTab.js
import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, Card, Button, Typography, Space, Skeleton, Empty, Tag, Tooltip, Popconfirm, message } from 'antd';
import { PlusOutlined, InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import NovaCategoriaMkt from './NovaCategoriaMkt';
import Metafields from './Metafields';
import { useConfigQuery } from '../../../../queries/useConfig';

const { Title, Text } = Typography;




const MarketplaceCategoriasTab = ({ categoria }) => {
    const [metafields, setMetafields] = useState([]);
    const accessToken = window?.localStorage?.getItem("accessToken");
    const { data: config } = useConfigQuery();
    const [categoriaSelecionada, setCategoriaSelecionada] = useState('');
    const [categorias, setCategorias] = useState();
    const [estoqueProduto, setEstoqueProduto] = useState(0);
    const [skuProduto, setSku] = useState("");
    const [statusProduto, setStatusProduto] = useState("");
    const [loading, setLoading] = useState(false);
    const [novaCategoria, setNovaCategoria] = useState(false);
    const [alterarMetafields, setAlterarMetafields] = useState(false);

    useEffect(() => {
        const carregarMetafields = async () => {
            if (!categoriaSelecionada) {
                return;
            }
            let inicial = [];

            // 1) Tenta buscar do novo endpoint metafields-mkt
            try {
                const options = {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + accessToken,
                    },
                };

                const resp = await axios.get(
                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/${config.idLoja}/metafields-mkt/id_ref_prod_cat/${categoria.id}/C/${categoriaSelecionada.idSaleChannel}`,
                    options
                );

                const data = resp.data;

                if (
                    data &&
                    typeof data.metafields === 'string' &&
                    data.metafields.trim() !== ''
                ) {
                    try {
                        const parsed = JSON.parse(data.metafields);


                        if (Array.isArray(parsed)) {
                            inicial = parsed;
                        } else {
                            console.warn('metafields do endpoint não é array após o parse:', parsed);
                        }
                    } catch (e) {
                        console.error('Erro ao converter data.metafields do endpoint:', e);
                    }
                }
            } catch (err) {
                console.error('Erro ao buscar metafields_mkt no endpoint novo:', err);
            }


            // 3) Monta estrutura com ids para a tela
            const comIds = (inicial.length ? inicial : []).map((mf, index) => ({
                id: `${Date.now()}-${index}`,
                key: mf?.key || '',
                value: mf?.value || '',
            }));

            if (comIds.length === 0) {
                comIds.push({
                    id: `${Date.now()}-0`,
                    key: '',
                    value: '',
                });
            }

            setMetafields(comIds);
        };

        if (categoria?.id && config?.idLoja && accessToken) {
            carregarMetafields();
        }
    }, [
        accessToken, categoriaSelecionada?.idSaleChannel, categoria
    ]);








    const STATUS_MAP = {
        5: { label: 'Ativo', color: 'green' },
        9: { label: 'Rascunho', color: 'default' },
    };

    function parseStatusCode(code) {
        if (code === null || code === undefined) return undefined;
        const n = Number(code);
        return Number.isNaN(n) ? undefined : n;
    }

    function deriveStatus(item) {
        // 1) Se o item já for um anúncio (tem saleChannelStatus), use direto
        const top = parseStatusCode(item?.saleChannelStatus);
        if (top && STATUS_MAP[top]) return STATUS_MAP[top];

        // 2) Se for o produto com ads, procure o status mais recente entre eles
        const ads = Array.isArray(item?.ads) ? item.ads : [];
        const updates = [];

        for (const ad of ads) {
            // status atual do anúncio
            const s = parseStatusCode(ad?.saleChannelStatus);
            if (s) {
                const dateStr =
                    ad?.updateDate || ad?.updatedAt || ad?.forsaledatestend || ad?.forsaledatestart;
                const d = dateStr ? new Date(dateStr) : new Date(0);
                updates.push({ date: isNaN(d) ? new Date(0) : d, status: s });
            }

            // histórico opcional (compatibilidade com formato antigo)
            const hist = ad?.saleChannelStatusUpdateDate || [];
            for (const u of hist) {
                const su = parseStatusCode(u?.saleChannelStatus);
                if (su) {
                    const du = u?.updateDate ? new Date(u.updateDate) : new Date(0);
                    updates.push({ date: isNaN(du) ? new Date(0) : du, status: su });
                }
            }
        }

        if (updates.length) {
            updates.sort((a, b) => b.date - a.date);
            const latest = updates[0].status;
            if (STATUS_MAP[latest]) return STATUS_MAP[latest];
        }

        // 3) Fallbacks
        if (item?.active === false) return { label: 'Indisponível', color: 'red' };
        if (ads.length === 0) return { label: 'Pausado', color: 'orange' };

        // se tem anúncios, mas não foi possível mapear status
        return { label: 'Pausado', color: 'orange' };
    }


    function formatBRL(n) {
        try { return n?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0,00'; }
        catch { return '0,00'; }
    }






    const voltar = () => {
        setNovaCategoria(false);
        fetchDetalhes();
    }


    const fetchDetalhes = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://apimarket.pedtech.com.br/v1/historico-associacao/${categoria.id}/${config.restaurante.cnpj}`, {
                headers: {
                    token: config.tokenMarketplace,
                },
                // signal: controller.signal,
            });
            setCategorias(resp.data);
        } catch (err) {
            if (axios.isCancel(err)) return;
            console.error('Erro ao buscar detalhes do produto:', err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (categoria.id) {
            fetchDetalhes();
        }
    }, [categoria.id]);


    const handleNovo = () => {
        // Abra modal/drawer de criação aqui
        console.log('Novo anúncio');
        setNovaCategoria(true);
    };
    const [deletingId, setDeletingId] = useState(null);
    async function handleDeleteAssoc(id) {
        const TOKEN = config.tokenMarketplace;
        const headers = { token: TOKEN }; // mantém seu esquema de header
        const CNPJ = config.restaurante.cnpj;

        if (!id) {
            message.error('ID não informado.');
            return;
        }

        try {
            setDeletingId(id);

            const resp = await axios.delete(
                `https://apimarket.pedtech.com.br/v1/historico-associacao/${id}/${CNPJ}`,
                { headers }
            );

            // aceita 200 ou 204 como sucesso
            if (resp.status === 200 || resp.status === 204) {
                setCategorias(prev =>
                    (prev ?? []).filter(cat => String(cat.id) !== String(id))
                );
                message.success('Associação removida com sucesso.');
            } else {
                message.warning(`Remoção retornou status ${resp.status}.`);
            }
        } catch (err) {
            console.error(err);
            message.error('Falha ao remover associação.');
        } finally {
            setDeletingId(null);
        }
    }



    const cards = useMemo(() => {
        if (!categorias) return null;

        return (categorias ?? []).map((categoria, idx) => {
            let img = '';
            if (categoria.saleschannellogo != null) {
                img = categoria.saleschannellogo;
            } else {
                img = `https://api.pedtech.com.br/imagens/mkt_img_1762369865`;
            }

            return (
                <Col key={categoria.id || `${categoria.alternativeId}-${idx}`} xs={24} sm={12} md={8} lg={6}>
                    <Card
                        hoverable
                        style={styles.cardSquare}
                        cover={
                            <div style={styles.coverInfo}>
                                <img src={img} alt="produto" style={styles.miniThumb} />
                                <div style={styles.coverText}>
                                    {/* LINHA DO CANAL + BOTÃO LADO A LADO */}
                                    <div style={styles.headerRow}>
                                        <Text type="secondary" style={{ color: '#000' }}>
                                            {categoria?.saleChannel}
                                        </Text>
                                        {' '}
                                        <Popconfirm
                                            title="Remover associação?"
                                            okText="Remover"
                                            cancelText="Cancelar"
                                            okButtonProps={{ danger: true }}
                                            onConfirm={(e) => {
                                                e?.stopPropagation?.();
                                                handleDeleteAssoc(categoria?.id);
                                            }}
                                            onCancel={(e) => e?.stopPropagation?.()}
                                        >
                                            <Button
                                                type="primary"
                                                size="small"
                                                danger
                                                icon={<DeleteOutlined />}
                                                loading={deletingId === categoria?.id}
                                                onClick={(e) => e.stopPropagation()} // evita abrir o onClick do Card
                                            />
                                        </Popconfirm>
                                    </div>

                                    <div style={styles.pillsRow}>
                                        <Tag color="blue">{`Canal: ${(`${categoria.idSaleChannel}` || 0)}`}</Tag>
                                    </div>


                                </div>
                            </div>
                        }
                        onClick={() => { setCategoriaSelecionada(categoria); setAlterarMetafields(true); }}
                    >
                        <Text type="secondary" style={{ color: '#000' }}>
                            {categoria.nomeCategoriaSaleChannel}{` (${categoria.idCategoriaSaleChannel})`}
                        </Text>
                    </Card>

                </Col>
            )
        });
    }, [categorias, deletingId, voltar]);


    return (
        alterarMetafields ?
            <Metafields elemento={categoria} tipo={'C'} canal={categoriaSelecionada.idSaleChannel} setElemento={setCategoriaSelecionada} metafields={metafields} setMetafields={setMetafields}></Metafields>
            : (!novaCategoria ?
                (<div>
                    <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                        <Button type="primary" icon={<PlusOutlined />} onClick={handleNovo} style={{ background: '#000', borderColor: '#000' }}>
                            Nova Categoria
                        </Button>
                    </div>

                    {loading ? (
                        <Row gutter={[16, 16]}>
                            {Array.from({ length: 6 }).map((_, i) => (
                                <Col key={i} xs={24} sm={12} md={8} lg={6}>
                                    <Card style={styles.cardSquare}>
                                        <Skeleton active avatar paragraph={{ rows: 3 }} />
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    ) : categorias?.ads?.length == 0 ? (
                        <Empty description="Nenhum anúncio cadastrado" />
                    ) : (
                        <Row gutter={[16, 16]}>{cards}</Row>
                    )}
                </div>) : (<NovaCategoriaMkt cnpj={config.restaurante.cnpj} voltar={voltar} categoriaId={categoria.id} ></NovaCategoriaMkt>))
    );
}

export default MarketplaceCategoriasTab;

const styles = {
    cardSquare: {
        width: '100%',
        borderRadius: 12,
        overflow: 'hidden',
        aspectRatio: '1 / 1',
        display: 'flex',
        flexDirection: 'column',
    },
    thumbWrap: {
        width: '100%',
        aspectRatio: '1 / 1',
        overflow: 'hidden',
        background: '#f2f2f2',
    },
    thumbImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },


    cardSquare: {
        width: '100%',
        borderRadius: 12,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        // removi o aspectRatio para não forçar quadrado rígido,
        // agora o conteúdo (cover informativo) define a altura
    },

    coverInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: 0,
        position: 'relative',
        background: '#fafafa',
        borderBottom: '1px solid #f0f0f0',

    },

    miniThumb: {
        width: 56,
        height: 56,
        objectFit: 'cover',
        borderRadius: 8,
        flex: '0 0 auto',
        background: '#f2f2f2',
    },

    coverText: {
        minWidth: 0, // permite ellipsis funcionar
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 4
    },

    pillsRow: {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
        marginTop: 2,
    },

    statusPill: {
        position: 'absolute',
        right: 12,
        top: 12,
    },

    metaRow: {
        display: 'flex',
        gap: 6,
        flexWrap: 'wrap',
    },

};

